"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodMapper = exports.paymentStatusMapper = void 0;
const payment_enums_1 = require("../enums/payment.enums");
const void_enums_1 = require("../enums/void.enums");
exports.paymentStatusMapper = {
    [void_enums_1.VoidTypeEnum.VOID]: payment_enums_1.PaymentStatusEnum.VOID,
    [void_enums_1.VoidTypeEnum.DISCOUNT]: payment_enums_1.PaymentStatusEnum.DISCOUNT,
    [void_enums_1.VoidTypeEnum.REVERT_DISCOUNT]: payment_enums_1.PaymentStatusEnum.REVERT_DISCOUNT,
};
exports.paymentMethodMapper = {
    [void_enums_1.VoidTypeEnum.VOID]: payment_enums_1.PaymentMethodTypeEnum.VOID,
    [void_enums_1.VoidTypeEnum.DISCOUNT]: payment_enums_1.PaymentMethodTypeEnum.DISCOUNT,
    [void_enums_1.VoidTypeEnum.REVERT_DISCOUNT]: payment_enums_1.PaymentMethodTypeEnum.REVERT_DISCOUNT,
};
//# sourceMappingURL=void.consts.js.map